import Loader from 'components/loader/Loader';

const PropertyLoader = () => {
  // TODO loading placeholders
  return <Loader />;
};

export default PropertyLoader;
